import React from "react";

/** Barra de consumo vs límite. Si limit es null, muestra valor sin barra proporcional. */
export default function UsageProgressBar({ used = 0, limit, label }) {
  const safeUsed = Number(used) || 0;
  const hasLimit = limit != null && limit > 0;
  const pct = hasLimit ? Math.min((safeUsed / limit) * 100, 100) : 0;
  const exceeded = hasLimit && safeUsed > limit;

  return (
    <div className="ops-usage-bar">
      {label && <span className="ops-usage-bar-label">{label}</span>}
      {hasLimit ? (
        <div className="ops-usage-bar-track">
          <div
            className={`ops-usage-bar-fill ${exceeded ? "exceeded" : ""}`}
            style={{ width: `${exceeded ? 100 : pct}%` }}
          />
        </div>
      ) : null}
      <span className={`ops-usage-bar-value ${exceeded ? "exceeded-text" : ""}`}>
        {safeUsed.toLocaleString("es-AR")}
        {hasLimit ? ` / ${Number(limit).toLocaleString("es-AR")}` : " (sin tope)"}
        {exceeded && <span className="ops-badge danger">Excedido</span>}
      </span>
    </div>
  );
}
